import * as React from "react";
import { TouchableOpacity, StyleSheet, View, TextInput } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { currentLanguage } from "../../translations/CurrentLanguage";

import translation from "../.././translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

export default class SearchComponent extends React.PureComponent {
  onClose = () => {
    if (this.props.status === "Item") {
      this.props.itemMaintenanceStatusChange(false);
    } else {
      this.props.onSearchClick(false);
    }
  };

  render() {
    strings.setLanguage(currentLanguage().companyLanguage);

    return (
      <View style={styles.header}>
        <View style={styles.field}>
          <Icon name="magnify" size={20} color={colors.textMuted} />
          <TextInput
            autoFocus
            style={styles.input}
            placeholder={strings.SearchItems}
            placeholderTextColor={colors.textFaint}
            underlineColorAndroid="transparent"
            onChangeText={this.props.onChangeText}
          />
          <TouchableOpacity onPress={this.onClose} style={styles.close}>
            <Icon name="close" size={18} color={colors.textMuted} />
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    height: 60,
    justifyContent: "center",
    paddingHorizontal: 16,
    backgroundColor: colors.navy,
  },
  field: {
    height: 42,
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 14,
    paddingRight: 6,
    borderRadius: 21,
    backgroundColor: "#fff",
  },
  input: {
    flex: 1,
    height: 42,
    marginLeft: 8,
    fontSize: 15,
    color: colors.text,
  },
  close: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
  },
});
